import { render, staticRenderFns } from "./list-segnalazioni-com.vue?vue&type=template&id=0350c0f0&"
import script from "./list-segnalazioni-com.vue?vue&type=script&lang=js&"
export * from "./list-segnalazioni-com.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports